import React from "react";
import { categoryList } from "../../../api/DoctorApi";
import CheckBox from "../checkbox/CheckBox";
import FilterListToggle from "../toggle/FilterListToggle";
import SliderProton from "../sliderRange/SliderRange";

const FilterPanel = ({
  selectedCategory,
  selectCategory,
  selectedPrice,
  cuisines,
  changeChecked,
  changePrice,
}) => (
  <div>
    <div className="experience">
      <h2 className="specialty-h2">Category</h2>
      <div className="input-group buttons">
        <FilterListToggle
          options={categoryList}
          value={selectedCategory}
          selectToggle={selectCategory}
        />
      </div>
    </div>

    <div className="specialty">
      <h2 className="specialty-h2">Specialty</h2>

      <div className="input-group">
        {cuisines.map((cuisine) => (
          <CheckBox
            key={cuisine.id}
            cuisine={cuisine}
            changeChecked={changeChecked}
          />
        ))}
      </div>
    </div>

    <div className="experience">
      <h2 className="specialty-h2">Year of Experience</h2>
      <div className="input-group">
        <p className="label-range"></p>
        <SliderProton value={selectedPrice} changePrice={changePrice} />
      </div>
    </div>
  </div>
);

export default FilterPanel;
